import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";

const ServiceAreaSection = () => {
  const areas = [
    "Stakeford",
    "Choppington",
    "Ashington",
    "Bedlington",
    "Morpeth",
    "Blyth",
    "Cramlington",
    "Guide Post",
  ];

  return (
    <section className="py-16 md:py-24 bg-white" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-12"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#8B5A2B] mb-4 block">
            Coverage Area
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A4D2E] mb-6">
            Serving Northumberland & Surrounding Areas
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Pioneer Trees and Landscapes Ltd provides professional landscaping, driveways, patios, garden design and tree surgery across Northumberland. Contact us to check if we cover your location.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d73000!2d-1.6!3d55.16!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487e6deb75ce7b5b%3A0x4cca29b0c1b17e36!2sChoppington!5e0!3m2!1sen!2suk"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Service Area Map - Northumberland"
              data-testid="service-area-map"
            />
          </motion.div>

          {/* Areas List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="bg-[#F9F9F7] rounded-2xl p-8">
              <h3 className="font-heading text-2xl font-bold text-[#1A4D2E] mb-6 flex items-center gap-2">
                <MapPin className="w-6 h-6 text-[#D97706]" />
                Areas We Cover
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {areas.map((area, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05, duration: 0.3 }}
                    className="flex items-center gap-2"
                  >
                    <div className="w-2 h-2 rounded-full bg-[#1A4D2E]" />
                    <span className="text-gray-700">{area}</span>
                  </motion.div>
                ))}
              </div>

              <div className="border-t border-gray-200 pt-6">
                <p className="text-gray-600 mb-4">
                  Not sure if we cover your area? Give us a call!
                </p>
                <a
                  href="tel:07968790128"
                  className="inline-flex items-center gap-2 bg-[#1A4D2E] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#143D24] transition-colors"
                  data-testid="service-area-call-btn"
                >
                  <Phone className="w-5 h-5" />
                  07968 790128
                </a>
              </div>
            </div>

            {/* Address Card */}
            <div className="mt-6 bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <h4 className="font-heading font-bold text-[#1A4D2E] mb-2">Our Office</h4>
              <p className="text-gray-600">
                15 Second Row<br />
                Ellington<br />
                NE61 5HE
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
